import reducer from './reducer'

import * as entityScreenSelectors from './selectors'

export { entityScreenSelectors }

export default reducer
